import PaymentMethods from './PaymentMethods';
import Services from './Services';
import ContactAndSync from './ContactAndSync';
import DeliveryProviders from './DeliveryProviders';
import DietaryInfo from './DietaryInfo';
import ImportantNotes from './ImportantNotes';
import PromotedProducts from './PromotedProducts';
import PhoneAnswering from './PhoneAnswering';

export default {
  PaymentMethods,
  Services,
  ContactAndSync,
  DeliveryProviders,
  DietaryInfo,
  ImportantNotes,
  PromotedProducts,
  PhoneAnswering,
};
